import React from "react";

interface CardItem {
  title: string;
  description: string;
}

interface CardSectionProps {
  cards: CardItem[];  // 接受一个包含卡片数据的数组
}

const CardSection: React.FC<CardSectionProps> = ({ cards }) => {
  return (
    <div className="container mx-auto px-6">
      <div className="grid md:grid-cols-3 gap-8">
        {cards.map((card, index) => (
          <div key={index} className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-bold mb-4">{card.title}</h3>
            <p>{card.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CardSection;